var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-small",
              on: { click: _vm.toPrint }
            },
            [_vm._v("打印")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("请购信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showRequireVoucherFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowRequireVoucher()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showRequireVoucherFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showRequireVoucherFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showRequireVoucherFlag
        ? [
            _c("div", { staticClass: "simple-form flex col-4" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.innerNo || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.goodsCount || 0))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        parseFloat(_vm.requireVoucher.wtxAmount || 0.0).toFixed(
                          2
                        )
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.requireVoucher.requireBizUnitName || "") +
                        "/" +
                        _vm._s(_vm.requireVoucher.requireComName || "")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.requireRealComName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.requireComNo || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.costCenterCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.prftCenterCode || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.applicantName || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.applicantContactTel || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.requireVoucher.appliedBizUnitName || "") +
                        "/" +
                        _vm._s(_vm.requireVoucher.appliedComName || "")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(11),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [_vm._v(_vm._s(_vm.requireVoucher.applicantName))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.applyTime || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.requireVoucher.requireDate || ""))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(14),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [_vm._v(_vm._s(_vm.requireVoucher.title || ""))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(15),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-value width-1-5x ellipsis",
                    staticStyle: { "white-space": "nowrap" },
                    attrs: { title: _vm.requireVoucher.desc }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.requireVoucher.desc || ""))])]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(16),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.requireVoucher.onlyForAsmblAcc ? "是" : "否")
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.requireBackConfirm
                ? _c("div", { staticClass: "form-group center" }, [
                    _vm._m(17),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value width-1-5x" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.requireVoucher.backConfirmPostName))
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.requireVoucher.goodsFlag
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("请购商品")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "shrink-tab fr ml10",
                class: _vm.showGoodsItemListFlag ? "current" : "",
                on: {
                  click: function($event) {
                    _vm.doShowGoodsItemList()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.showGoodsItemListFlag ? "隐藏" : "展开"))
                ]),
                _vm._v(" "),
                _c("i", {
                  class: _vm.showGoodsItemListFlag
                    ? "el-icon-arrow-down"
                    : "el-icon-arrow-right"
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "fr", staticStyle: { "font-size": "12px" } },
              [
                _vm._v(
                  "包含组装件总数：" + _vm._s(_vm.totalAsmblAccSetCount || 0)
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "fr mr10", staticStyle: { "font-size": "12px" } },
              [
                _vm._v(
                  "含税总金额(元)：" +
                    _vm._s(
                      parseFloat(_vm.requireVoucher.wtxAmount || 0).toFixed(2)
                    )
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showGoodsItemListFlag && _vm.requireVoucher.goodsFlag
        ? _c("div", { staticClass: "table-layout" }, [
            _c(
              "div",
              {
                staticClass: "table-layout",
                staticStyle: { "overflow-x": "auto" }
              },
              [
                _c(
                  "table",
                  { staticClass: "custom-tbl" },
                  [
                    _c("thead", { staticClass: "head" }, [
                      _c("tr", { staticClass: "row" }, [
                        _c("th", { attrs: { width: "60" } }, [_vm._v("序号")]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "left" },
                            attrs: { width: "180" }
                          },
                          [_vm._v("购置部门")]
                        ),
                        _vm._v(" "),
                        _vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "180" }
                              },
                              [_vm._v("资产定义编码")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "180" }
                              },
                              [_vm._v("资产描述全称")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("型号")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("规格")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("品牌")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "left" },
                            attrs: { width: "180" }
                          },
                          [_vm._v("名称")]
                        ),
                        _vm._v(" "),
                        !_vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("品牌名称")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("型号")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("规格")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { width: "100" }
                          },
                          [_vm._v("申请数量")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { width: "110" }
                          },
                          [_vm._v("含税价(元)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { width: "110" }
                          },
                          [_vm._v("含税小计(元)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { width: "90" }
                          },
                          [_vm._v("税率(%)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "left" },
                            attrs: { width: "180" }
                          },
                          [_vm._v("供应商")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "left" },
                            attrs: { width: "180" }
                          },
                          [_vm._v("供方公司")]
                        ),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "60" } }, [_vm._v("单位")]),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "80" } }, [
                          _vm._v("是否定制\t")
                        ]),
                        _vm._v(" "),
                        _vm.showAssetInfo
                          ? _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("资产分类名称")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "left" },
                            attrs: { width: "120" }
                          },
                          [_vm._v("分类名称")]
                        ),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "80" } }, [
                          _vm._v("仅组装件")
                        ]),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "80" } }, [
                          _vm._v("采购模式")
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { width: "110" }
                          },
                          [_vm._v("未税价(元)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { width: "110" }
                          },
                          [_vm._v("所需组装件数量")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { width: "110" }
                          },
                          [_vm._v("包含组装件数量")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "left" },
                            attrs: { width: "180" }
                          },
                          [_vm._v("发货数量")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticStyle: { "text-align": "left" },
                            attrs: { width: "180" }
                          },
                          [_vm._v("收货数量")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.goodsItemList, function(goodsItem, index) {
                      return _c(
                        "tbody",
                        { staticClass: "body" },
                        [
                          _c("tr", { staticClass: "row" }, [
                            _c(
                              "td",
                              {
                                attrs: {
                                  rowspan: goodsItem.itemList.length + 1
                                }
                              },
                              [_c("span", [_vm._v(_vm._s(index + 1))])]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "left" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(goodsItem.requireComName || ""))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(goodsItem.assetDefNo || ""))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(goodsItem.devcTitle || ""))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(goodsItem.devcModel || ""))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(goodsItem.devcFixedSpec || "")
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(goodsItem.devcBrandName || "")
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "left" } },
                              [
                                _vm.showAssetInfo
                                  ? _c("span", [
                                      _vm._v(_vm._s(goodsItem.devcName || ""))
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(goodsItem.name || ""))
                                    ])
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(goodsItem.goodsBrandName || "")
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(goodsItem.model || ""))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(goodsItem.fixedSpec || ""))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                !goodsItem.onlyForAsmblAcc
                                  ? _c("span", [
                                      _vm._v(_vm._s(goodsItem.quantity))
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                goodsItem.price != null
                                  ? _c("span", [
                                      _vm._v(_vm._s(goodsItem.price.toFixed(2)))
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                goodsItem.wtxAmount != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(goodsItem.wtxAmount.toFixed(2))
                                      )
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                goodsItem.taxRate != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(goodsItem.taxRate.toFixed(2))
                                      )
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "left" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(goodsItem.vendorName || ""))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "left" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(goodsItem.vendorRealComName || "")
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm.showAssetInfo
                                ? _c("span", [
                                    _vm._v(_vm._s(goodsItem.devcUnit || ""))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(goodsItem.unit || ""))
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              goodsItem.customized
                                ? _c("span", [_vm._v("是")])
                                : _c("span", [_vm._v("否")])
                            ]),
                            _vm._v(" "),
                            _vm.showAssetInfo
                              ? _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(goodsItem.innerDevcCatName || "")
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "left" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(goodsItem.goodsCatName || ""))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", [
                              goodsItem.onlyForAsmblAcc
                                ? _c("span", [_vm._v("是")])
                                : _c("span", [_vm._v("否")])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              goodsItem.centBuyMode
                                ? _c("span", [_vm._v("集采")])
                                : _c("span", [_vm._v("自采")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                goodsItem.ntxPrice != null
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(goodsItem.ntxPrice.toFixed(2))
                                      )
                                    ])
                                  : _c("span", [_vm._v("0.00")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(goodsItem.asmblAccReqCount || 0)
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(goodsItem.asmblAccSetCount || 0)
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(goodsItem.shipQuantity))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(goodsItem.recvQuantity))
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(goodsItem.itemList, function(
                            asmblAccItem,
                            itemIndex
                          ) {
                            return _c("tr", { staticClass: "row" }, [
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(goodsItem.requireComName || "")
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(asmblAccItem.accDefNo || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(asmblAccItem.devcTitle || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(asmblAccItem.devcModel || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            asmblAccItem.devcFixedSpec || ""
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            asmblAccItem.devcBrandName || ""
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _vm.showAssetInfo
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(asmblAccItem.devcName || "")
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(_vm._s(asmblAccItem.name || ""))
                                      ])
                                ]
                              ),
                              _vm._v(" "),
                              !_vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            asmblAccItem.goodsBrandName || ""
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(asmblAccItem.model || ""))
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(asmblAccItem.fixedSpec || "")
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(asmblAccItem.quantity))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  asmblAccItem.price != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(asmblAccItem.price.toFixed(2))
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  asmblAccItem.wtxAmount != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            parseFloat(
                                              asmblAccItem.wtxAmount
                                            ).toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  asmblAccItem.taxRate != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            asmblAccItem.taxRate.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(asmblAccItem.vendorName || "")
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        asmblAccItem.vendorRealComName || ""
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm.showAssetInfo
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(asmblAccItem.devcUnit || "")
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(_vm._s(asmblAccItem.unit || ""))
                                    ])
                              ]),
                              _vm._v(" "),
                              _vm._m(18, true),
                              _vm._v(" "),
                              _vm.showAssetInfo
                                ? _c(
                                    "td",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            goodsItem.innerDevcCatName || ""
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(asmblAccItem.goodsCatName || "")
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(19, true),
                              _vm._v(" "),
                              _vm._m(20, true),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  asmblAccItem.ntxPrice != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            asmblAccItem.ntxPrice.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              ),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td", {
                                staticStyle: { "text-align": "left" }
                              }),
                              _vm._v(" "),
                              _c("td", {
                                staticStyle: { "text-align": "left" }
                              })
                            ])
                          })
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _vm.goodsItemList == null || _vm.goodsItemList.length <= 0
                      ? _c("tbody", { staticClass: "body" }, [_vm._m(21)])
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.requireVoucher.servcFlag
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("请购服务")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "shrink-tab fr",
                class: _vm.showServcItemListFlag ? "current" : "",
                on: {
                  click: function($event) {
                    _vm.doShowServcItemList()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.showServcItemListFlag ? "隐藏" : "展开"))
                ]),
                _vm._v(" "),
                _c("i", {
                  class: _vm.showServcItemListFlag
                    ? "el-icon-arrow-down"
                    : "el-icon-arrow-right"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showServcItemListFlag && _vm.requireVoucher.servcFlag
        ? _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.servcItemList,
                    border: "",
                    "max-height": "400"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "服务名称",
                      fixed: "",
                      "min-width": "200"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "requireComName",
                      label: "购置部门",
                      width: "250"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "servcCatName",
                      label: "分类名称",
                      width: "150"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "servcBrandName",
                      label: "品牌名称",
                      width: "150"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "desc", label: "描述", "min-width": "300" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fileList.length > 0
        ? _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("附件管理")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "shrink-tab fr",
                class: _vm.showFileItemFlag ? "current" : "",
                on: {
                  click: function($event) {
                    _vm.doShowFileItem()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.showFileItemFlag ? "隐藏" : "展开"))
                ]),
                _vm._v(" "),
                _c("i", {
                  class: _vm.showFileItemFlag
                    ? "el-icon-arrow-down"
                    : "el-icon-arrow-right"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showFileItemFlag && _vm.fileList.length > 0
        ? [
            _c(
              "div",
              { staticClass: "file-view-list" },
              [
                _vm._m(22),
                _vm._v(" "),
                _vm._l(_vm.fileList, function(fileInfo, index) {
                  return [
                    _c("swb-file-item-li", {
                      attrs: {
                        trackKey: index,
                        fileName: fileInfo.name,
                        fileBrowseUrl: fileInfo.fileBrowseUrl,
                        fileDownloadUrl: fileInfo.fileBrowseUrl,
                        fileUuid: fileInfo.fileUuid,
                        deletable: false
                      }
                    })
                  ]
                })
              ],
              2
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("审核记录")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showOaAuditFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowOaAuditInfo()
              }
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.showOaAuditFlag ? "隐藏" : "展开"))]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showOaAuditFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showOaAuditFlag
        ? [
            _vm.requireVoucher.id != null && !_vm.requireVoucher.outerAuditFlag
              ? _c("swb-device-require-audit-rec-list", {
                  ref: "swb_device_require_audit_rec_list",
                  attrs: { item: _vm.requireVoucher.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.requireVoucher.id != null && _vm.requireVoucher.outerAuditFlag
              ? [
                  _c("swb-oa-audit-rec-list", {
                    ref: "swb_oa_audit_rec_list",
                    attrs: {
                      bizTypeCode: "retailer.assets.purch",
                      bizVoucherNo: _vm.bizVoucherNo,
                      auditSeqNo: _vm.requireVoucher.auditSeqNo
                    }
                  })
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("请购单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("请购总数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("请购总金额(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("购置部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("购置公司")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("成本中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("利润中心")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("电话")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请部门")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("经办人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("请购日期")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("采购需求")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单独采购组装件")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("回溯确认岗")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: { "text-align": "center", "line-height": "40px" },
          attrs: { colspan: "16" }
        },
        [_c("span", [_vm._v("暂无数据...")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file-view-header" }, [
      _c("div", { staticClass: "file-name" }, [_vm._v("名称")]),
      _vm._v(" "),
      _c("div", { staticClass: "file-opera" }, [_vm._v("操作")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5822743c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5822743c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/RequireGoodsItemList.vue
// module id = 2884
// module chunks = 0